import { Link } from '@tanstack/react-router';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDisplayDate } from '@/utils/date';
import { formatTaka } from '@/utils/number';
import type { PcmpInstituteProposal } from '../../types/pcmpProposal.types';
import { PcmpProposalSection } from './PcmpProposalSection';

interface PcmpInstituteProposalsCardProps {
  proposals: PcmpInstituteProposal[];
}

const NUMBER_CELL = 'text-right tabular-nums';

/** The school's other proposals, any project; hidden when there are none. */
export function PcmpInstituteProposalsCard({ proposals }: PcmpInstituteProposalsCardProps) {
  if (proposals.length === 0) return null;
  return (
    <PcmpProposalSection title="Other Proposals for this School">
      <div className="max-h-96 overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Ref</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Project</TableHead>
              <TableHead>Teacher</TableHead>
              <TableHead className="text-right">Proposed</TableHead>
              <TableHead className="text-right">Disbursed</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {proposals.map((proposal) => (
              <TableRow key={proposal.proposalId}>
                <TableCell className="font-medium">
                  <Link
                    to="/pcmp/proposals/$proposalId"
                    params={{ proposalId: proposal.proposalId }}
                    className="text-primary underline-offset-4 hover:underline"
                  >
                    {proposal.refNo}
                  </Link>
                </TableCell>
                <TableCell>{formatDisplayDate(proposal.proposalDate)}</TableCell>
                <TableCell>{proposal.projectName}</TableCell>
                <TableCell>
                  <div className="flex flex-col">
                    <span>{proposal.teacherName}</span>
                    {proposal.teacherMobile ? (
                      <span className="text-xs text-muted-foreground">
                        {proposal.teacherMobile}
                      </span>
                    ) : null}
                  </div>
                </TableCell>
                <TableCell className={NUMBER_CELL}>{formatTaka(proposal.proposedAmount)}</TableCell>
                <TableCell className={NUMBER_CELL}>{formatTaka(proposal.paidAmount)}</TableCell>
                <TableCell>
                  {proposal.status.label}
                  {proposal.isOnHold ? (
                    <span className="ml-1 text-xs text-muted-foreground">(on hold)</span>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </PcmpProposalSection>
  );
}
